export default function Footer() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/18594205881?text=Hola%2C%20necesito%20información%20sobre%20sus%20servicios', '_blank');
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/7390baca68aebcb14217ef53907c4fd1/befe6694d70ed20c4ba5133d375d2a98.png"
                alt="PaisaNet Logo"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              Ayudando a la comunidad latina en Kentucky con servicios administrativos y oportunidades para emprender.
            </p>
            <button
              onClick={handleWhatsApp}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Contáctanos
            </button>

            {/* Social Media */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.facebook.com/paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-blue-600 rounded-full transition-all duration-300 cursor-pointer"
                aria-label="Facebook de PaisaNet"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-pink-600 rounded-full transition-all duration-300 cursor-pointer"
                aria-label="Instagram de PaisaNet"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-gray-600 rounded-full transition-all duration-300 cursor-pointer"
                aria-label="TikTok de PaisaNet"
              >
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">Servicios</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line"></i>
                  Creación de LLC
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line"></i>
                  Obtención de EIN
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line"></i>
                  Registro de vehículos
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line"></i>
                  Reparación de crédito
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line"></i>
                  Créditos para negocios
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Información</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-green-400 mt-1"></i>
                <div>
                  <p className="font-semibold">Ubicación</p>
                  <p className="text-gray-300">Kentucky, Estados Unidos</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-xl text-green-400 mt-1"></i>
                <div>
                  <p className="font-semibold">Horario</p>
                  <p className="text-gray-300">Lun - Vie: 9:00 AM - 6:00 PM</p>
                  <p className="text-gray-300">Sáb: 10:00 AM - 2:00 PM</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-global-line text-xl text-green-400 mt-1"></i>
                <div>
                  <p className="font-semibold">Idiomas</p>
                  <p className="text-gray-300">Español e Inglés</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 PaisaNet. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@paisanet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
            <p className="text-gray-400 text-sm text-center">
              Servicios enfocados en ayudar a la comunidad latina con negocios y procesos administrativos
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}